
import {
    GET_ADMIN_TICKETS_SUCCESS,
    GET_ADMIN_TICKETS_FAIL,
    GET_ADMIN_TICKET_DETAIL_SUCCESS,
    GET_ADMIN_TICKET_DETAIL_FAIL,
    UPDATE_TICKET_STATUS_SUCCESS,
    UPDATE_TICKET_STATUS_FAIL,
    REPLY_TICKET_SUCCESS,
    REPLY_TICKET_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    tickets: [],
    meta: {},
    ticketDetail: null,
    error: {},
}

const TicketsAdmin = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ADMIN_TICKETS_SUCCESS:
            return {
                ...state,
                tickets: action.payload.data,
                meta: action.payload,
            }

        case GET_ADMIN_TICKETS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_ADMIN_TICKET_DETAIL_SUCCESS:
            return {
                ...state,
                ticketDetail: action.payload,
            }

        case GET_ADMIN_TICKET_DETAIL_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_TICKET_STATUS_SUCCESS:
            return {
                ...state,
                ticketDetail: action.payload,
                tickets: state.tickets.map(ticket =>
                    ticket.id.toString() === action.payload.id.toString()
                        ? action.payload
                        : ticket
                ),
            }

        case UPDATE_TICKET_STATUS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case REPLY_TICKET_SUCCESS:
            return {
                ...state,
                ticketDetail: {
                    ...state.ticketDetail,
                    messages: [...state.ticketDetail.messages, action.payload],
                },
            }

        case REPLY_TICKET_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default TicketsAdmin
